// Disable zod's JIT schema compilation for the browser bundle.
//
// The strict Content-Security-Policy served for login.budsrewards.com uses
// `script-src 'self'` with no `'unsafe-eval'`. zod v4 has an eval-based fast
// path whose feature-probe runs `new Function('')` the first time a z.object is
// constructed; under this CSP that call is blocked, throws an EvalError zod
// swallows, and — harmlessly but noisily — emits a CSP violation report. Setting
// `jitless` short-circuits the probe's sole reader, so `new Function` is never
// attempted. Validation behaviour is identical; JIT is a server-throughput
// optimisation irrelevant to a login form.
//
// IMPORTANT: this must run before any module that *defines* a zod schema, since
// the probe fires at schema construction (import time), not at parse time. It is
// therefore imported as the very first side-effect in main.tsx, above the App
// import that pulls in @repo/auth-contracts. Do not add imports above it there.
import { z } from 'zod';

z.config({ jitless: true });
